export class Credentials {

  constructor(
    public username?: string,
    public password?: string) {
  }
}
